import React from "react";

import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Widget from "components/Widget/index";
import { connect } from 'react-redux';
import FolderItemCard from './FolderItemCard'

import {
  loadFolders,
  saveFolderID, deleteFolderById
} from 'actions/MyFolders';

import {
  saveProjectID,
} from 'actions/MyProjects';

class Folder {
  constructor(key, createdById, hasNews, name) {
    this.key = key;
    this.createdById = createdById;
    this.hasNews = hasNews;
    this.name = name;
  }
}

class FolderCard extends React.Component {

  state = {
    activeTab: '1'
  };



  componentDidMount() {

    var userID = localStorage.getItem('user_id');
    var projectID = localStorage.getItem('project_id');
    console.log("############FOLDER_CARD - DID MOUNT");
    this.props.loadFolders({ userID, projectID });

  }

  render() {

    console.log("######### RENDER FOLDER CARD");

    if(this.props.update){

      console.log("############# FOLDER CARD - RAMO UPDATE");

      var userID = localStorage.getItem('user_id');
      var projectID = localStorage.getItem('project_id');
      this.props.loadFolders({ userID, projectID });

      return (
        <div
          style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >NON CI SONO CARTELLE</div>
      )

    }else if (this.props.myFolderList ) {
      console.log("############# FOLDER CARD - IF RENDER");
      var data_list = [];
      this.props.myFolderList.forEach(function (childSnapshot) {
        var key = childSnapshot.key;

        var createdById = childSnapshot.val().createdById;
        var hasNews = childSnapshot.val().hasNews;
        var name = childSnapshot.val().name;

        var folder = new Folder(key, createdById, hasNews, name);

        data_list.push(folder);
      });


      return (
        <Widget  >

          <div className="jr-news-action jr-tabs-classic jr-tabs-classic-no-border">
            <div className="jr-tabs-up jr-tabs-up-no-border">
            </div>

            <TabContent className="jr-tabs-content" activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                {data_list.map((data, index) =>
                  <FolderItemCard key={index} data={data} props={this.props} />
                )}
              </TabPane>

            </TabContent>
          </div>
        </Widget>
      );
    }
    else {

      return (
        <div
          style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >NON CI SONO CARTELLE</div>
      )
    }
  }
}

const mapStateToProps = ({ myProjects, myFolders, auth }) => {
  const { myFolderList,update } = myFolders;
  const { selectedProjectID } = myProjects;
  const { authUser } = auth;
  return { myFolderList, selectedProjectID, authUser,update }
};

export default connect(mapStateToProps, {
  saveFolderID, saveProjectID, loadFolders, deleteFolderById
})(FolderCard);
